"use client"

import { useEffect } from "react"
import { FiCheckCircle } from "react-icons/fi"

export default function SuccessModal({ isOpen, onClose, autoRedirectDelay = 3000 , message}) {
  useEffect(() => {
    let timer
    if (isOpen) {
      timer = setTimeout(() => {
        onClose()
      }, autoRedirectDelay)
    }
    return () => clearTimeout(timer)
  }, [isOpen, onClose, autoRedirectDelay])

  if (!isOpen) return null


  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full shadow-xl">
        <div className="flex flex-col items-center text-center">
          <FiCheckCircle className="h-16 w-16 text-blue-900 mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Success!</h3>
          <p className="text-gray-600 mb-6">{message}</p>
          <button
            onClick={onClose}
            className="mt-6 bg-[#036494] text-white py-2 px-6 rounded-full hover:bg-[#075985] transition-colors"
          >
            Continue Now
          </button>
        </div>
      </div>
    </div>
  )
}